export class GetAttachmentModel {
  solicitationId!: number;
  fileName!: string;
  file!: File;
  fileSize!: number;
  uploaded!: boolean;
  loading: boolean = false;
}
